// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-size: 1rem;
}

.progress-bar {
  border: 0;
  flex-direction: row;
}
.progress-bar-card {
  background-color: #FDF8F2;
}
.progress-bar-success {
  background-color: #CCE9DE;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/progress-bar/progress-bar.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/progress-bar/progress-bar.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;ACDF;;ADIA;EACE,SAAA;EACA,mBAAA;ACDF;ADEE;EACE,yBAAA;ACAJ;ADEE;EACE,yBAAA;ACAJ","sourcesContent":["@use \"../../../assets/styles/global/utils\" as u;\r\n\r\np {\r\n  font-size: u.rem(16px);\r\n}\r\n\r\n.progress-bar {\r\n  border: 0;\r\n  flex-direction: row;\r\n  &-card {\r\n    background-color: #FDF8F2;\r\n  }\r\n  &-success {\r\n    background-color: #CCE9DE;\r\n  }\r\n}","p {\n  font-size: 1rem;\n}\n\n.progress-bar {\n  border: 0;\n  flex-direction: row;\n}\n.progress-bar-card {\n  background-color: #FDF8F2;\n}\n.progress-bar-success {\n  background-color: #CCE9DE;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
